import loadable from '@loadable/component';

export const AuthResetPasswordPageLoadable = loadable(
  () => import('./AuthResetPasswordPage'),
  { resolveComponent: (module) => module.AuthResetPasswordPage },
);
